if (!customElements.get('reviews-marquee')) {
  customElements.define('reviews-marquee', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const button = this.querySelector('.rm__pause');
      button.hidden = false;
      button.addEventListener('click', () => {
        const paused = this.toggleAttribute('data-paused');
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? 'Resume reviews' : 'Pause reviews');
        button.textContent = paused ? '▶' : 'Ⅱ';
      }, options);
      this.addEventListener('error', event => {
        if (event.target.matches?.('.rm__photo')) event.target.hidden = true;
      }, { ...options, capture: true });
      this.querySelectorAll('.rm__photo').forEach(img => {
        if (img.complete && !img.naturalWidth) img.hidden = true;
      });
      this.addEventListener('shopify:block:select', event => {
        this.setAttribute('data-editing', '');
        event.target.scrollIntoView({ block: 'nearest', inline: 'center' });
      }, options);
      this.addEventListener('shopify:block:deselect', () => this.removeAttribute('data-editing'), options);
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
